export function Wordmark({ size = 40 }: { size?: number }) {
  return (
    <h1
      className="font-bold tracking-tight text-[var(--colour-primary)] leading-none"
      style={{ fontSize: size, letterSpacing: "-0.02em" }}
    >
      forkd<span className="text-[var(--colour-accent)]">.</span>
    </h1>
  );
}
